import CreateAccountForm from 'components/CreateAccountForm';
import React from 'react';
import styled from 'styled-components';
import Header, { HeaderVariant } from 'shared/Header';
import { Footer } from 'components/Footer/Footer';

const CreateAccount = () => {
  return (
    <Wrapper>
      <Header variant={HeaderVariant.dark} />

      <CreateAccountWrapper>
        <CreateAccountForm />
      </CreateAccountWrapper>

      <Footer background="#000" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: var(--spacing-80);
  background: #000;
`;

const CreateAccountWrapper = styled.div`
  padding-top: var(--spacing-32);
  padding-left: var(--spacing-24);
  padding-right: var(--spacing-24);
  padding-bottom: var(--spacing-64);
  width: min(400px, 100%);
  margin-bottom: auto;
`;

export default CreateAccount;
